import { EmailSettingsFormPage } from "~/pages/EmailSettingsFormPage";
import { trpc } from "~/utils/trpc";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";

export const Route = createFileRoute("/_dashboard/$datasetSlug/settings/email-settings/templates/edit/$id")({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  useBreadCrumbs([
    { title: "Email Settings", link: `/${params.datasetSlug}/settings/email-settings` },
    { title: "Edit", link: `/${params.datasetSlug}/settings/email-settings/edit/${params.id}` },
  ]);
  const { data: emailSetting, isFetchedAfterMount } = useQuery({
    ...trpc.emailSettings.getById.queryOptions({ id: params.id }),
    refetchOnMount: true,
    staleTime: 0,
  });
  if (!isFetchedAfterMount) return null;
  return <EmailSettingsFormPage emailSetting={emailSetting} />;
}
